import type { ReactNode } from 'react'
import type { LucideIcon } from 'lucide-react'

import { cn } from '@/lib/utils'

/** Shared typography + layout for icon-labelled identity metadata rows. */
export const entityMetadataRowClass =
  'flex items-center gap-2 text-base text-muted-foreground'

type EntityMetadataRowProps = {
  icon: LucideIcon
  children: ReactNode
  className?: string
}

/** Icon + label row for entity identity cards (profile, organisation, public share). */
export function EntityMetadataRow({ icon: Icon, children, className }: EntityMetadataRowProps) {
  return (
    <p className={cn(entityMetadataRowClass, className)}>
      <Icon className="h-4 w-4 shrink-0 translate-y-px" aria-hidden />
      {children}
    </p>
  )
}

type EntityMetadataInlineRowProps = {
  children: ReactNode
  className?: string
}

/** Wrapping row for multiple inline metadata chips (e.g. company size + founded). */
export function EntityMetadataInlineRow({ children, className }: EntityMetadataInlineRowProps) {
  return (
    <p
      className={cn(
        'flex flex-wrap items-center gap-x-4 gap-y-2 text-base text-muted-foreground',
        className,
      )}
    >
      {children}
    </p>
  )
}
